import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=669f6d46&"
import script from "./CardHeader.vue?vue&type=script&lang=js&"
export * from "./CardHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('669f6d46')) {
      api.createRecord('669f6d46', component.options)
    } else {
      api.reload('669f6d46', component.options)
    }
    module.hot.accept("./CardHeader.vue?vue&type=template&id=669f6d46&", function () {
      api.rerender('669f6d46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/card-layout/CardHeader.vue"
export default component.exports